import axios from 'axios';
import store from '@/store';

export default {
  async verifyEmail(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      payload.lang = store.state.langSelected.langWsp;
      let resp = await axios.post(`${apiUrl}/dps/tenant/verifyEmail?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      return {
        error: true
      };
    }
  },

  async createInvitation(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      payload.lang = store.state.langSelected.langWsp;
      resp = await axios.post(`${apiUrl}/dps/tenant/createTenantInvitation?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      return {
        error: true,
        status: error.status
      };
    }
  },

  async createTeletagTenant(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      payload.lang = store.state.langSelected.langWsp;
      resp = await axios.post(`${apiUrl}/dps/tenant/createTeletagTenant?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      if (error.status === 412) {
        let jsonData;
        try {
          jsonData = JSON.parse(error.data.error);
        } catch (err) {}

        return {
          data: jsonData,
          error: true,
          status: error.status
        };
      }

      return {
        error: true,
        status: error.status
      };
    }
  },

  async invitations(params) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      params.lang = store.state.langSelected.langWsp;
      let resp = await axios.get(`${apiUrl}/dps/tenant/invitations`, {
        params: params
      });

      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      return {
        error: true
      };
    }
  },

  async resendInvitation(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      payload.lang = store.state.langSelected.langWsp;
      resp = await axios.post(`${apiUrl}/dps/tenant/resendInvitation?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      let jsonData;
      try {
        jsonData = JSON.parse(error.data.error);
      } catch (err) {}
      return {
        error: true,
        data: jsonData
      };
    }
  },

  async deleteInvitation(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      payload.lang = store.state.langSelected.langWsp;
      resp = await axios.post(`${apiUrl}/dps/tenant/deleteTenantInvitation?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      let jsonData;
      try {
        jsonData = JSON.parse(error.data.error);
      } catch (err) {}
      return {
        error: true,
        data: jsonData
      };
    }
  },

  async verifyTag(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      payload.lang = store.state.langSelected.langWsp;
      let resp = await axios.post(`${apiUrl}/dps/tenant/verifyTag?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      return {
        error: true
      };
    }
  },

  async verifyKeypad(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      payload.lang = store.state.langSelected.langWsp;
      let resp = await axios.post(`${apiUrl}/dps/tenant/verifyKeypad?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      return {
        error: true
      };
    }
  },

  async editTenantBle(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      payload.lang = store.state.langSelected.langWsp;
      resp = await axios.post(`${apiUrl}/dps/tenant/editTenantBle?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      if (error.status === 412) {
        let jsonData;
        try {
          jsonData = JSON.parse(error.data.error);
        } catch (err) {}

        return {
          data: jsonData,
          error: true,
          status: error.status
        };
      }

      return {
        error: true,
        status: error.status
      };
    }
  },

  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      params.lang = store.state.langSelected.langWsp;
      let resp = await axios.get(`${apiUrl}/dps/tenant/list`, {
        params: params
      });
      callback(resp.data);
    } catch (error) {
      console.log(error);
      errorCallback();
    }
  },

  async deleteTenant(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      payload.lang = store.state.langSelected.langWsp;
      let resp = await axios.post(`${apiUrl}/dps/tenant/deleteTenant?lang=${payload.lang}`, payload);
      return resp.data;
    } catch (error) {
      return {
        error: error.data
      };
    }
  },

  async editTenantTag(payload) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      payload.lang = store.state.langSelected.langWsp;
      let resp = await axios.post(`${apiUrl}/dps/tenant/editTenantTag?lang=${payload.lang}`, payload);
      return {
        error: false,
        data: resp.data
      };
    } catch (error) {
      if (error.status === 412) {
        let jsonData;
        try {
          jsonData = JSON.parse(error.data.error);
        } catch (err) {}

        return {
          data: jsonData,
          error: true,
          status: error.status
        };
      }

      return {
        error: true,
        status: error.status
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/tenantService.js